// 부동산 개발·매매사례 분석실(/re) — 비주거 부동산 비교사례법 + 개발가능성 사전검토 (베타, 내부 사용자).
//
// 노출 게이트: 아래 호스트에서만 켠다. 2026-09-04 dev 전용으로 시작해 같은 날 프로덕션(value-agent.deepsearch.com)도
// 열었다(사용자 결정). 다른 호스트에서는 사이드바 항목과 /re·/re/report 라우트가 잡히지 않는다
// (리포트 REPORT_ENABLED · Graph DB 챗 GRAPH_CHAT_ENABLED 와 같은 킬스위치 관행). 숨겨야 하면 여기서 호스트를 뺀다.
// 목록 밖 호스트에서 점검이 필요하면 브라우저 콘솔에서 localStorage.setItem("va_re_force", "1") 뒤 새로고침.
const ENABLED_HOSTS = /^(value-agent\.deepsearch\.com|value-agent-dev\.deepsearch\.com|localhost|127\.0\.0\.1|\[::1\])$/i;

export function realEstateEnabledFor(hostname: string, forced = false): boolean {
  return forced || ENABLED_HOSTS.test((hostname || "").trim());
}

function forcedFlag(): boolean {
  try { return localStorage.getItem("va_re_force") === "1"; } catch { return false; }
}

export const RE_ENABLED: boolean = typeof window !== "undefined" ? realEstateEnabledFor(window.location.hostname, forcedFlag()) : false;
